export default function GitHub_Pages() {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-4">GitHub Pages</h1>

      <p className="mt-4 text-gray-500 text-sm">Path: /git/github/pages</p>
    </div>
  );
}
